import { Col, Container, Row } from 'react-bootstrap'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './PharmaProducts.css'


const PharmaProducts = () => {
    return (
        <main className='pharmaproducts'>
            <Container>
                <Row>
                    <h2>Nuestros servicios en farmacia</h2>
                    <Col md={12} className='my-4'>
                        <VerticalTimeline lineColor={ '#000' }>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Control continuo y monitorización de Temperatura para el correcto almacenaje de medicamentos</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Asesoramiento continuo sobre actualizaciones de Normativas</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Servicio técnico</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Suministro de soluciones y equipos para el desarrollo de la actividad farmaceutica</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Control y Asesoramiento documental</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Calibración de equipos de Precisión y control</p>
                            </VerticalTimelineElement>
                        </VerticalTimeline>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default PharmaProducts